// // dev、本番ののurlを定義
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL
export const API_SANCTUM_URL = process.env.REACT_APP_API_SANCTUM_URL


